import React from "react";
import { TextArea } from "@truevault/aquilo";
import { CONSENT_TEXTAREA_CLASSES } from "../../../consentBanner/consentFieldStyles";
import { ConsentSettingRow } from "../../../consentBanner/ConsentSettingRow";

/**
 * Optional English disclaimer text shown at the top of the Manage Preferences screen for opt-in and
 * opt-out banners (rendered by polaris-cmp as `interactiveBanner.enPreferencesDisclaimerText`).
 * Only shown to orgs with the CmpPreferencesDisclaimer feature; see POL-7875.
 */
export const ConsentBannerPreferencesDisclaimerRow = () => {
  return (
    <ConsentSettingRow
      title="Disclaimer"
      adornment={
        <span className="rounded-[4px] bg-neutral-100 px-[7px] py-[1px] text-[12px] font-medium leading-[16px] text-neutral-600">
          Optional
        </span>
      }
      helpText="Shown above the consent toggles on the English opt-in and opt-out banners. Basic HTML formatting is supported."
    >
      <div className="w-full">
        <TextArea
          field="bannerPreferencesDisclaimerTextEn"
          className={CONSENT_TEXTAREA_CLASSES}
          aria-label="Preferences screen disclaimer"
          placeholder="Leave blank to show no disclaimer"
          rows={4}
        />
      </div>
    </ConsentSettingRow>
  );
};
